// removed by extract-text-webpack-plugin
module.exports = {"Quiz":"src-components-ProgramOverview-Quiz----Quiz-module---Quiz---3EtxM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProgramOverview/Quiz/Quiz.module.scss
// module id = 739
// module chunks = 184655746423024